import { apiClient } from './apiClient';
import type {
  NotificationTemplateDto,
  NotificationTemplateListItemDto,
  UpdateNotificationTemplateRequest,
} from './types/notificationTemplate.types';

export const notificationTemplateApi = {
  getAll: async (activeOnly = true): Promise<NotificationTemplateListItemDto[]> => {
    try {
      const res = await apiClient.get('/notification-templates', {
        params: { activeOnly },
      });
      return res.data;
    } catch (error) {
      console.error('Failed to fetch notification templates:', error);
      throw error;
    }
  },

  getById: async (id: number): Promise<NotificationTemplateDto> => {
    try {
      const res = await apiClient.get(`/notification-templates/${id}`);
      return res.data;
    } catch (error) {
      console.error('Failed to fetch notification template:', error);
      throw error;
    }
  },

  update: async (id: number, request: UpdateNotificationTemplateRequest): Promise<void> => {
    try {
      await apiClient.put(`/notification-templates/${id}`, request);
    } catch (error) {
      console.error('Failed to update notification template:', error);
      throw error;
    }
  },
};
